import { render, staticRenderFns } from "./servAppraiseManage.vue?vue&type=template&id=65ec3f38&scoped=true"
import script from "./servAppraiseManage.vue?vue&type=script&lang=js"
export * from "./servAppraiseManage.vue?vue&type=script&lang=js"
import style0 from "./servAppraiseManage.vue?vue&type=style&index=0&id=65ec3f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec3f38",
  null
  
)

export default component.exports